/* eslint-disable func-names */
import React from "react";
import { debounce, get } from "lodash";
import { toast } from "react-toastify";
import {
  MIGRATE_PROJECT_ACTION,
  ROLES_ACTION,
  USER_MANAGEMENT_ACTION
} from "../constant";
import * as apiServices from "../services/apiServices";
import request from "../services/requestService";
import { successToastStyle, errorToastStyle } from "../customToast";
export const getGroupsListAction = (param, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_GROUP_LIST_START
    });
    return requestMethod(apiServices._getGroupsList(param))
      .then(response => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUP_LIST_SUCCESS,
          payload: {
            data: get(response, "data.data"),
            status: get(response, "data.status"),
            message: get(response, "data.message")
          }
        });
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_ROLES_LIST_FAILURE
        });
      });
  };
};

export const getUserOtp = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_USER_OTP_START
    });
    return requestMethod(apiServices.getOtp())
      .then(res => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USER_OTP_SUCCESS,
          payload: {
            data: get(res, "data.data"),
            status: get(res, "data.status"),
            message: get(res, "data.message")
          }
        });
        return {
          data: get(res, "data.data"),
          status: get(res, "data.status"),
          message: get(res, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USER_OTP_FAILURE
        });
      });
  };
};

export const getGroupsAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_GROUPS_START
    });
    return requestMethod(apiServices.getGroups())
      .then(response => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUPS_SUCCESS,
          payload: {
            data: get(response, "data.data"),
            status: get(response, "data.status"),
            message: get(response, "data.message")
          }
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUPS_FAILURE
        });
      });
  };
};

export const getGroupListFilter = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_GROUP_LIST_FILTER_START
    });
    return requestMethod(apiServices._getGroupListFilter())
      .then(response => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUP_LIST_FILTER_SUCCESS,
          payload: {
            data: get(response, "data.data"),
            status: get(response, "data.status"),
            message: get(response, "data.message")
          }
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUP_LIST_FILTER_FAILURE
        });
      });
  };
};

export const getGroupsForUserAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_GROUPS_FOR_USER_START
    });
    return requestMethod(apiServices.getGroupsForUsers())
      .then(response => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUPS_FOR_USER_SUCCESS,
          payload: {
            data: get(response, "data.data"),
            status: get(response, "data.status"),
            message: get(response, "data.message")
          }
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUPS_FOR_USER_FAILURE
        });
      });
  };
};

export const getRolesAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_ROLES_LIST_START
    });
    return requestMethod(apiServices.getRolesList())
      .then(response => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_ROLES_LIST_SUCCESS,
          payload: {
            data: get(response, "data.data"),
            status: get(response, "data.status"),
            message: get(response, "data.message")
          }
        });
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_ROLES_LIST_FAILURE
        });
      });
  };
};

export const getCategoryAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_START
    });
    return requestMethod(apiServices.getCategoryList())
      .then(response => {
        const data = {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_FAILURE
        });
      });
  };
};

export const getGroupCategoryForRoleAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_FOR_ROLE_START
    });
    return requestMethod(apiServices.getCategoryForRoleList())
      .then(response => {
        const _data = (get(response, "data.data") || []).map(item => {
          return {
            value: item,
            label: item
          };
        });
        const data = {
          data: _data || [],
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_FOR_ROLE_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_CATEGORY_LIST_FOR_ROLE_FAILURE
        });
      });
  };
};

export const createGroupAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.CREATE_GROUP_START
    });
    return requestMethod(apiServices.createGroup(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_GROUP_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_GROUP_FAILURE
        });
      });
  };
};

export const updateGroupAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.CREATE_GROUP_START
    });
    return requestMethod(apiServices.createGroup(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_GROUP_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_GROUP_FAILURE
        });
      });
  };
};

export const deleteGroupAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.DELETE_GROUP_START
    });
    return requestMethod(apiServices.deleteGroup(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.DELETE_GROUP_SUCCESS
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.DELETE_GROUP_FAILURE
        });
      });
  };
};

export const getRolesByIdAction = (requestMethod = request, param) => {
  return function(dispatch) {
    // dispatch({
    //   type: USER_MANAGEMENT_ACTION.GET_ROLES_BY_ID_START
    // });
    return requestMethod(apiServices.getRolesById(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        // dispatch({
        //   type: USER_MANAGEMENT_ACTION.GET_ROLES_BY_ID_SUCCESS,
        //   payload: data
        // });
        return data;
      })
      .catch(err => {
        // dispatch({
        //   type: USER_MANAGEMENT_ACTION.GET_ROLES_BY_ID_FAILURE
        // });
      });
  };
};

export const getGroupRolesForUser = (requestMethod = request, id) => {
  return function(dispatch) {
    return requestMethod(apiServices._getGroupRolesForUser(id))
      .then(response => {
        return {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        // dispatch({
        //   type: USER_MANAGEMENT_ACTION.GET_ROLES_BY_ID_FAILURE
        // });
      });
  };
};

export const createUserAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.CREATE_USER_START
    });
    return requestMethod(apiServices.createUser(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_USER_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_USER_FAILURE
        });
      });
  };
};

export const updateUserAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.CREATE_USER_START
    });
    return requestMethod(apiServices.updateUser(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_USER_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_USER_FAILURE
        });
      });
  };
};

export const updateBestPracticesAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.UPDATE_BEST_PRACTICES_START
    });
    return requestMethod(apiServices.updateBestPractices(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.UPDATE_BEST_PRACTICES_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.UPDATE_BEST_PRACTICES_FAILURE
        });
      });
  };
};

export const createBestPracticesAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.CREATE_BEST_PRACTICES_START
    });
    return requestMethod(apiServices.createBestPractices(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_BEST_PRACTICES_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.CREATE_BEST_PRACTICES_FAILURE
        });
      });
  };
};

export const deleteBestPracticeAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.DELETE_BEST_PRACTICES_START
    });
    return requestMethod(apiServices.deleteBestPractice(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.DELETE_BEST_PRACTICES_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.DELETE_BEST_PRACTICES_FAILURE
        });
      });
  };
};

export const getGroupsByCategoryAction = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_GROUP_BY_ID_START
    });
    return requestMethod(apiServices.getGroupsByCategoryAction(id))
      .then(response => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUP_BY_ID_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_GROUP_BY_ID_FAILURE
        });
      });
  };
};

export const getGroupRoles = (requestMethod = request, param) => {
  return requestMethod(apiServices.getRolesById(param))
    .then(response => {
      const data = {
        data: get(response, "data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
      return data;
    })
    .catch(err => {});
};

export const createRoleAction = (requestMethod = request, param) => {
  return function(dispatch) {
    dispatch({
      type: ROLES_ACTION.CREATE_ROLES_START
    });
    return requestMethod(apiServices.createRole(param))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        dispatch({
          type: ROLES_ACTION.CREATE_ROLES_SUCCESS,
          payload: data
        });
        return data;
      })
      .catch(err => {
        dispatch({
          type: ROLES_ACTION.CREATE_ROLES_FAILURE
        });
      });
  };
};

// export const getPermissionsAction = (requestMethod = request) => {
//   return function(dispatch) {
//     return requestMethod(apiServices.getPermissionsListing())
//       .then(response => {
//         const { data } = response;
//         return  {
//           data: get(data, "data", []),
//           status: get(data, "status", false),
//           message: get(data, "message", "")
//         }
//       })
//       .catch(err => {
//
//       });
//   };
// };

export const getUsersListAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_START
    });
    return requestMethod(apiServices.getUsersList(params))
      .then(response => {
        const { data } = response;
        const responseData = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_SUCCESS,
          payload: responseData
        });
        return responseData;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_FAILURE
        });
      });
  };
};

export const getBestPracticesList = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_START
    });
    return requestMethod(apiServices.getBestPracticesList(params))
      .then(response => {
        const { data } = response;
        const responseData = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_SUCCESS,
          payload: responseData
        });
        return responseData;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_FAILURE
        });
      });
  };
};

export const getBestPracticesCount = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_START
    });
    return requestMethod(apiServices.getBestPracticesCount(params))
      .then(response => {
        const { data } = response;
        const responseData = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_SUCCESS,
          payload: responseData
        });
        return responseData;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_FAILURE
        });
      });
  };
};

export const getIIGDraftUsersListAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_START
    });
    return requestMethod(apiServices.getIIGDraftUsersList(params))
      .then(response => {
        const { data } = response;
        const responseData = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_SUCCESS,
          payload: responseData
        });
        return responseData;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_FAILURE
        });
      });
  };
};

export const getBestPracticesListForHome = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_START
    });
    return requestMethod(apiServices.getBestPracticesListForHome(params))
      .then(response => {
        const { data } = response;
        const responseData = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_SUCCESS,
          payload: responseData
        });
        return responseData;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_FAILURE
        });
      });
  };
};

export const getBestPracticesCountForHome = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_START
    });
    return requestMethod(apiServices.getBestPracticesCountForHome(params))
      .then(response => {
        const { data } = response;
        const responseData = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_SUCCESS,
          payload: responseData
        });
        return responseData;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_BEST_PRACTICES_LIST_FAILURE
        });
      });
  };
};

export const getDraftUserCount = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_START
    });
    return requestMethod(apiServices.getDraftUserCount())
      .then(response => {
        const { data } = response;
        const responseData = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_SUCCESS,
          payload: responseData
        });
        return responseData;
      })
      .catch(err => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GET_USERS_LIST_FAILURE
        });
      });
  };
};

export const getGuestList = (requestMethod = request, param) => {
  return requestMethod(apiServices.getGuestListParams(param))
    .then(response => {
      const data = {
        data: get(response, "data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
      return data;
    })
    .catch(err => {});
};

export const isManagementModeRuning = (requestMethod = request, param) => {
  return requestMethod(apiServices.isEditGroupManagmentRuning(param))
    .then(response => {
      const data = {
        data: get(response, "data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
      return data;
    })
    .catch(err => {});
};

export const makeUserActiveAction = (requestMethod = request, userId) => {
  return function(dispatch) {
    return requestMethod(apiServices.makeUserActiveApi(userId))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
        return data;
      })
      .catch(err => {});
  };
};

export const migrateProjectAction = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: MIGRATE_PROJECT_ACTION.MIGRATE._START
    });
    return requestMethod(apiServices.migrateProjectApi(data))
      .then(response => {
        const data = {
          data: get(response, "data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };

        const message = get(response, "data.message");
        get(response, "data.status")
          ? toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );

        dispatch({
          type: MIGRATE_PROJECT_ACTION.MIGRATE._SUCCESS
        });
      })
      .catch(err => {
        dispatch({
          type: MIGRATE_PROJECT_ACTION.MIGRATE._FAILURE
        });
      });
  };
};

export const getMigrateProjectListAction = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: MIGRATE_PROJECT_ACTION.PROJECT_LIST._START
    });
    return requestMethod(apiServices.getMigrateProjectListApi(data))
      .then(response => {
        const res = {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };

        const message = get(response, "data.message");
        get(response, "data.data", []).length
          ? toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">
                No project(s) is available for migration.
              </p>,
              errorToastStyle
            );

        dispatch({
          type: MIGRATE_PROJECT_ACTION.PROJECT_LIST._SUCCESS,
          payload: res
        });
        return res;
      })
      .catch(() => {
        dispatch({
          type: MIGRATE_PROJECT_ACTION.PROJECT_LIST._FAILURE
        });
      });
  };
};

export const clearMigrateDataAction = () => {
  return function(dispatch) {
    dispatch({
      type: MIGRATE_PROJECT_ACTION.MIGRATE._CLEAR
    });
  };
};

export const updateMigrateDataAction = data => {
  return function(dispatch) {
    dispatch({
      type: MIGRATE_PROJECT_ACTION.MIGRATE._UPDATE,
      payload: data
    });
  };
};

export const getParentGroupsByCategory = (param, requestMethod = request) => {
  return function(dispatch) {
    return requestMethod(apiServices._getParentGroupsByCategory(param))
      .then(response => {
        return get(response, "data");
      })
      .catch(err => {
        console.log("error in getParentGroupsByCategory");
      });
  };
};

export const getDownloadUsersListAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.USERS_LIST._START
    });
    return requestMethod(apiServices.downloadUsersListReport(params))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: USER_MANAGEMENT_ACTION.USERS_LIST._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: USER_MANAGEMENT_ACTION.USERS_LIST._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.USERS_LIST._FAILURE
        });
      });
  };
};

export const clearUsersListDownloadAction = () => {
  return dispatch => {
    dispatch({
      type: USER_MANAGEMENT_ACTION.USERS_LIST._CLEAR
    });
  };
};

export const getDownloadGroupsListAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GROUPS_LIST._START
    });
    return requestMethod(apiServices.downloadGroupsListReport(params))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: USER_MANAGEMENT_ACTION.GROUPS_LIST._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: USER_MANAGEMENT_ACTION.GROUPS_LIST._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: USER_MANAGEMENT_ACTION.GROUPS_LIST._FAILURE
        });
      });
  };
};

export const clearGroupsListDownloadAction = () => {
  return dispatch => {
    dispatch({
      type: USER_MANAGEMENT_ACTION.GROUPS_LIST._CLEAR
    });
  };
};

const debouncePromise = function(time, key, callback) {
  const callApi = debounce(async () => {
    const downLoadResp = await request(apiServices.downloadExcel({ key: key }));
    const { data, status } = downLoadResp.data;
    if (!status) {
      return debouncePromise(time + 500, key, callback);
    } else {
      typeof callback === "function" && callback(data);
    }
  }, time);
  callApi();
};
